import { makeStyles } from "@mui/styles";
import { FontFamilySwitch } from "../../../utils";

export const useStyles = makeStyles((theme) => ({
    cells: {
        display: "flex",
        justifyContent: "center",
        height: "auto",
        border: `1px solid ${theme.palette.border.secondary}`,
        alignItems: "center",
        padding: 8
    },
    content_cells: {
        // display: "flex",
        // height: "auto",
        border: `1px solid ${theme.palette.border.secondary}`,
        padding: 6
    },
    dayLabel: {
        fontSize:"0.75rem",
        textTransform: "uppercase",
        color: theme.typography.color.tertiary
    },
    dateLabel: {
        fontSize:"1rem",
        fontWeight: "bold",
        textTransform: "uppercase",
        color: theme.typography.color.secondary
    },
    time_label: {
        fontSize:"0.75rem",
        color: theme.typography.color.tertiary,
        textAlign: "center"
    },
    content: {
        height: "100%",
        // overflow: "auto"
    },
    filterbox:{
        height: "34px",
        width: "34px",
        borderRadius: "4px",
        border: "1px solid #CED3DD",
        alignItems:"center",
        cursor:"pointer"
    },

}))

export const ScheduleCardStyle = makeStyles((theme) => ({
    card: {
        // height: 50,
        padding: 6,
        width: "100%",
        cursor: "pointer"
    },
    avatar: {
        height: 22,
        width: 22,
        // marginTop: 4
    },
    status: {
        fontSize:"0.75rem",
        fontWeight: "bold",
        whiteSpace: "nowrap",

        marginInlineStart: "8px"

    },
    status1: {
        fontSize:"0.75rem",
        fontWeight: "bold",
        whiteSpace: "nowrap",
        marginInlineStart: "8px"
    },
    request: {
        fontSize:"0.75rem",
    },
    countNo: {
        fontSize:"1rem",
        fontFamily: FontFamilySwitch().bold,
        color: theme.typography.color.secondary,
        marginInlineStart: "8px"
    },
    type: {
        fontSize:"0.875rem",
        fontFamily: FontFamilySwitch().semiBold,
        color: theme.typography.color.secondary
    },
    viewAll: {
        fontSize:"0.75rem",
        fontFamily: FontFamilySwitch().bold,
        color: "#5078E1",
        textAlign: "center",
        marginTop: "20px"
    }
}))
export const HeaderStyles = makeStyles((theme) => ({
    dateLabel: {
        fontSize:"0.875rem",
        fontWeight: "bold",
        color: theme.typography.color.primary
    },
    button: {
        border: `1px solid ${theme.palette.border.secondary}`,
        height: 35,
        width: 35,
        textAlign: "center"
    },
    button_icon: {
        fontSize:"1rem",
        color: theme.typography.color.tertiary
    },
    dropdown: {
        border: `1px solid ${theme.palette.border.secondary}`,
        borderRadius: 6,
        cursor: "pointer",
        zIndex: 1,
        position: "relative",
        backgroundColor: "#fff",

    },
    list: {
        position: "absolute",
        zIndex: 1,
        backgroundColor: "#fff",
        width: "100%",
        left: 0,
        padding: "12px",
        borderRight: `1px solid ${theme.palette.border.secondary}`,
        borderLeft: `1px solid ${theme.palette.border.secondary}`,
        borderBottom: `1px solid ${theme.palette.border.secondary}`,
    },
    dropdown_name: {
        fontSize:"0.875rem",
        color: theme.typography.color.primary,
        fontWeight: "bold",
        marginInlineStart: "8px"
    },
    dropdown_user_type: {
        fontSize:"0.75rem",
        color: theme.typography.color.tertiary
    },
    dropdown_icon: {
        fontSize: 20,
        color: theme.typography.color.tertiary
    },

}))
export const CustomDropDownStyles = makeStyles((theme) => ({
    customdrp: {
        border: `1px solid ${theme.palette.border.secondary}`,
        borderRadius: 6,
        cursor: "pointer",
        right: "3%",
        backgroundColor: "#fff",
        top: "23%",
        width: "128px",
        padding: "8px 16px"
    },
    selected: {
        '&:hover': {
            color: theme.palette.info.main
        }
    }
}))
export const MonthlyCalendarStyles = makeStyles((theme) => ({
    // calendar dates styles
    calDates: {
        textAlign: "center",

    },
    date: {
        color: theme.typography.color.secondary,
        fontSize:"1.125rem",
        fontWeight: "bold"
    },
    date_outline: {
        color: "black",
        border: `1px solid ${theme.palette.border.secondary}`,
        height: 90,
    },
    hidden_other_month_dates: {
        visibility: "hidden"
    },
    eventlabel: {
        overflow: "hidden",
        width: "98%",
    },
    eventtxt: {
        whiteSpace: "nowrap",
        width: "99%",
        fontSize:"0.75rem",
    },
    moreLabel: {
        float: "left",
        fontSize:"0.75rem",
        fontWeight: "bold",
        color: theme.palette.info.main,
    },
    daysText: {
        textAlign: "center",
        marginBottom: "8px",
        fontSize:"0.75rem",
        color: theme.typography.color.tertiary,
        fontFamily: FontFamilySwitch().regular,
    }
}))
export const DayCalendarStyles = makeStyles((theme) => ({
    header_timecell: {
        height: 40,
        fontSize:"0.75rem",
        color: theme.typography.color.tertiary,
        textTransform: "uppercase",
        borderLeft: `0.5px solid ${theme.palette.border.secondary}`,
        borderBottom: `0.5px solid ${theme.palette.border.secondary}`,
        borderTop: `1px solid ${theme.palette.border.secondary}`,
        width: "100%",
        padding: 4,
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    },
    timeCell: {
        display: "flex",
        justifyContent: "center",
        height: 100,
        fontSize:"0.75rem",
        color: theme.typography.color.tertiary,
        borderLeft: `0.5px solid ${theme.palette.border.secondary}`,
        borderBottom: `0.5px solid ${theme.palette.border.secondary}`,

    },
    header_eventCell: {
        height: 40,
        border: `1px solid ${theme.palette.border.secondary}`,
        width: "100%",
        padding: 4,
        display: "flex",
        justifyContent: "left",
        alignItems: "center"
    },
    eventCell: {
        //height: 100,
        borderLeft: `1px solid ${theme.palette.border.secondary}`,
        borderRight: `1px solid ${theme.palette.border.secondary}`,
        borderBottom: `1px solid ${theme.palette.border.secondary}`,
        width: "100%",
        //overflow: "auto"
    },
    event_label: {
        padding: 2,
        fontSize:"0.75rem",
        fontWeight: "bold",
        textTransform: "capitalize"
    },
    dot: {
        height: 5,
        width: 5,
        borderRadius: "50%",
    },
    calRow: {
        height: "calc(100vh - 300px)",
        overflow: "auto",
        width: "100%",

    },
    moreLabel: {
        fontSize:"0.75rem",
        color: theme.palette.info.main,
        fontWeight: "bold",
        marginLeft: 8,
        cursor: "pointer"
    },
    customTooltip: {
        // '& .MuiTooltip-arrow':{
        //     backgroundColor:"#fff",
        //     color:"#fff",
        //     border: '1px solid #dadde9'
        // }
        '& .MuiTooltip-arrow': {
            background: 'red',
        },
        "&:before": {
            border: "1px solid #E6E8ED"
        },

    },
    ttavatar: {
        height: 24,
        width: 24,
    },
    ttTitle: {
        fontSize:"0.875rem",
        fontWeight: "bold",
        color: theme.typography.color.primary,
        textTransform: "capitalize"
    },
    ttsecTitle: {
        fontSize:"0.75rem",
        textTransform: "capitalize",
        color: theme.typography.color.secondary,
    },
    ttassigned_by: {
        fontSize:"0.75rem",
        color: theme.typography.color.tertiary
    },
    ttname: {
        fontSize:"1rem",
        color: theme.typography.color.secondary,
        fontWeight: "bold"
    },
    arrow: {
        "&:before": {
            border: "1px solid #E6E8ED"
        },
        color: "white",
        position: "absolute",
        top: "0px",
        left: "0px",
        fontSize: "40px"
    },
    toolRoot: {
        border: '1px solid #E4E8EE',
        boxShadow: "0px 0px 16px #00000014",
        backgroundColor: "white",
        borderRadius: "4px",

    },
    menuItem: {
        backgroundColor: "#FFFFFF !important",
        "&:hover": {
            backgroundColor: "#FFFFFF !important",
        }
    },
    menuList: {
        backgroundColor: "#FFFFFF !important",
        "&:hover": {
            backgroundColor: "#FFFFFF !important",
        },

    },
    MuiListItemButton: {
        styleOverrides: {
            root: {
                backgroundColor: '#FFFFFF !important',
            }
        },
    },
}))
